import { Component, OnInit, ViewContainerRef , Renderer2} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { Helper } from '../helpers/helper';
import { LocalstorageService } from '../localstorage.service';

@Component({
  selector: 'echexpayment-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.css']
})
export class PermissionComponent implements OnInit {
	
	public token: string;
	show: boolean = true;
    busy: Subscription;
    public data;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "updated_at";
    public sortOrder = "desc";

    public roleList : string;
	
	constructor(private router: Router, vcRef: ViewContainerRef, private renderer: Renderer2, public modal: Modal, private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 

	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	
	
	}

	ngOnInit() {
		this.getAllPermission();
	}
	
	// Get All permissions
	getAllPermission(){
		var data = {
			token:this.token,
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getAllPermissionList(data).subscribe(
		 response => {
		  responseData = response;
		  this.data = responseData.data;
		 },
		 error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		 }
		);  
	}
	// delete permission by _id
	deletePermission(event,p_id){
		let responseData = <any>{};
		event.stopPropagation();
		this.modal.confirm()
		  .size('sm')
		  .title('CasherPay')
		  .body(`Are you sure to delete this permission.
				`
			  )
		  .okBtn('Okay')
		  .cancelBtn('Cancel')
		  .okBtnClass('btn btn-success')
		  .cancelBtnClass('btn btn-warning')
		.open()
		.then( (resultPromise) => {
			resultPromise.result.then( (result) => {
			  var data = {
				token:this.token,
				id:p_id
			  }
			this.busy = this.echexpaymentService.deletePermission(data).subscribe(
				 response => {
					responseData = response;
					this.toastr.success(responseData.message, 'Success!');
					this.getAllPermission();
				 },
				 error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				}
			);
		  }, 
		  () => {
		   console.log('Cancel');
		  } );
		});
	}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/permission/permission.component.ts